import React from 'react';
import {
  Edit2, ExternalLink, Cable, Copy, Mail, Trash2, Plus, ArrowLeftRight,
} from 'lucide-react';

export default function NodeContextMenu({ x, y, node, onClose, onAction }) {
  if (!node) return null;

  const items = [
    { id: 'view-database', label: 'View in Tech Database', icon: ExternalLink },
    { id: 'show-integrations', label: 'Show Integrations', icon: Cable },
    node.used ? { id: 'reassign', label: 'Reassign Solution', icon: ArrowLeftRight } : { id: 'quick-fill', label: 'Assign Solution', icon: Plus },
    node.used ? { id: 'remove-assignment', label: 'Remove Assignment', icon: Trash2, danger: true } : null,
    { id: 'copy-id', label: `Copy ID: ${node.id}`, icon: Copy },
    node.support_url ? { id: 'open-support', label: 'Open Support Portal', icon: Mail } : null,
  ].filter(Boolean);

  return (
    <>
      <div className="fixed inset-0 z-50" onClick={onClose} />
      <div
        className="fixed z-50 bg-card border rounded-lg shadow-xl py-1 min-w-[200px] animate-in fade-in zoom-in-95 duration-100"
        style={{ left: Math.min(x, window.innerWidth - 220), top: Math.min(y, window.innerHeight - items.length * 36 - 20) }}
        data-testid="node-context-menu"
      >
        <div className="px-3 py-1.5 border-b">
          <span className="text-xs font-semibold">{node.name}</span>
          {node.vendor_name && <span className="text-[10px] text-muted-foreground block">{node.vendor_name}</span>}
        </div>
        {items.map(item => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => { onAction(item.id, node); onClose(); }}
              className={`w-full flex items-center gap-2.5 px-3 py-1.5 text-xs hover:bg-muted/60 transition-colors ${item.danger ? 'text-destructive' : ''}`}
              data-testid={`ctx-${item.id}`}
            >
              <Icon className="h-3.5 w-3.5 shrink-0" />
              {item.label}
            </button>
          );
        })}
      </div>
    </>
  );
}
